var map = {
	"./flags/1x1/AC.svg": 31116,
	"./flags/1x1/AD.svg": 65300,
	"./flags/1x1/AE.svg": 99708,
	"./flags/1x1/AF.svg": 67280,
	"./flags/1x1/AG.svg": 46060,
	"./flags/1x1/AI.svg": 74596,
	"./flags/1x1/AL.svg": 71288,
	"./flags/1x1/AM.svg": 54280,
	"./flags/1x1/AO.svg": 41224,
	"./flags/1x1/AQ.svg": 28312,
	"./flags/1x1/AR.svg": 89300,
	"./flags/1x1/AS.svg": 67120,
	"./flags/1x1/AT.svg": 23684,
	"./flags/1x1/AU.svg": 93964,
	"./flags/1x1/AW.svg": 30204,
	"./flags/1x1/AX.svg": 17932,
	"./flags/1x1/AZ.svg": 5756,
	"./flags/1x1/BA.svg": 36668,
	"./flags/1x1/BB.svg": 10008,
	"./flags/1x1/BD.svg": 91744,
	"./flags/1x1/BE.svg": 72530,
	"./flags/1x1/BF.svg": 70852,
	"./flags/1x1/BG.svg": 42124,
	"./flags/1x1/BH.svg": 3320,
	"./flags/1x1/BI.svg": 9380,
	"./flags/1x1/BJ.svg": 95136,
	"./flags/1x1/BL.svg": 98408,
	"./flags/1x1/BM.svg": 2168,
	"./flags/1x1/BN.svg": 28896,
	"./flags/1x1/BO.svg": 66727,
	"./flags/1x1/BQ.svg": 56736,
	"./flags/1x1/BR.svg": 39252,
	"./flags/1x1/BS.svg": 75400,
	"./flags/1x1/BT.svg": 14864,
	"./flags/1x1/BV.svg": 42504,
	"./flags/1x1/BW.svg": 6427,
	"./flags/1x1/BY.svg": 39476,
	"./flags/1x1/BZ.svg": 41244,
	"./flags/1x1/CA.svg": 45403,
	"./flags/1x1/CC.svg": 95216,
	"./flags/1x1/CD.svg": 84556,
	"./flags/1x1/CF.svg": 50416,
	"./flags/1x1/CG.svg": 59044,
	"./flags/1x1/CH.svg": 2552,
	"./flags/1x1/CI.svg": 90604,
	"./flags/1x1/CK.svg": 65832,
	"./flags/1x1/CL.svg": 16536,
	"./flags/1x1/CM.svg": 96357,
	"./flags/1x1/CN.svg": 34964,
	"./flags/1x1/CO.svg": 15344,
	"./flags/1x1/CR.svg": 16868,
	"./flags/1x1/CU.svg": 6642,
	"./flags/1x1/CV.svg": 20300,
	"./flags/1x1/CW.svg": 85792,
	"./flags/1x1/CX.svg": 24436,
	"./flags/1x1/CY.svg": 14223,
	"./flags/1x1/CZ.svg": 93405,
	"./flags/1x1/DE.svg": 67304,
	"./flags/1x1/DJ.svg": 14116,
	"./flags/1x1/DK.svg": 69036,
	"./flags/1x1/DM.svg": 14572,
	"./flags/1x1/DO.svg": 12036,
	"./flags/1x1/DZ.svg": 97736,
	"./flags/1x1/EC.svg": 36680,
	"./flags/1x1/EE.svg": 5008,
	"./flags/1x1/EG.svg": 41135,
	"./flags/1x1/EH.svg": 60776,
	"./flags/1x1/ER.svg": 81468,
	"./flags/1x1/ES.svg": 7584,
	"./flags/1x1/ET.svg": 15624,
	"./flags/1x1/FI.svg": 86292,
	"./flags/1x1/FJ.svg": 83676,
	"./flags/1x1/FK.svg": 37424,
	"./flags/1x1/FM.svg": 12660,
	"./flags/1x1/FO.svg": 24476,
	"./flags/1x1/FR.svg": 50308,
	"./flags/1x1/GA.svg": 21816,
	"./flags/1x1/GB.svg": 42568,
	"./flags/1x1/GD.svg": 27512,
	"./flags/1x1/GE.svg": 38860,
	"./flags/1x1/GF.svg": 90080,
	"./flags/1x1/GG.svg": 4304,
	"./flags/1x1/GH.svg": 35692,
	"./flags/1x1/GI.svg": 86304,
	"./flags/1x1/GL.svg": 80256,
	"./flags/1x1/GM.svg": 42216,
	"./flags/1x1/GN.svg": 48328,
	"./flags/1x1/GP.svg": 84584,
	"./flags/1x1/GQ.svg": 86228,
	"./flags/1x1/GR.svg": 40984,
	"./flags/1x1/GS.svg": 29036,
	"./flags/1x1/GT.svg": 92423,
	"./flags/1x1/GU.svg": 70243,
	"./flags/1x1/GW.svg": 57248,
	"./flags/1x1/GY.svg": 85328,
	"./flags/1x1/HK.svg": 28992,
	"./flags/1x1/HM.svg": 58536,
	"./flags/1x1/HN.svg": 26028,
	"./flags/1x1/HR.svg": 74096,
	"./flags/1x1/HT.svg": 63240,
	"./flags/1x1/HU.svg": 15768,
	"./flags/1x1/ID.svg": 22112,
	"./flags/1x1/IE.svg": 31924,
	"./flags/1x1/IL.svg": 17220,
	"./flags/1x1/IM.svg": 22232,
	"./flags/1x1/IN.svg": 81512,
	"./flags/1x1/IO.svg": 46012,
	"./flags/1x1/IQ.svg": 91388,
	"./flags/1x1/IR.svg": 58792,
	"./flags/1x1/IS.svg": 9192,
	"./flags/1x1/IT.svg": 28624,
	"./flags/1x1/JE.svg": 28508,
	"./flags/1x1/JM.svg": 60844,
	"./flags/1x1/JO.svg": 29344,
	"./flags/1x1/JP.svg": 92215,
	"./flags/1x1/KE.svg": 2264,
	"./flags/1x1/KG.svg": 30556,
	"./flags/1x1/KH.svg": 60940,
	"./flags/1x1/KI.svg": 76808,
	"./flags/1x1/KM.svg": 90751,
	"./flags/1x1/KN.svg": 20696,
	"./flags/1x1/KP.svg": 52168,
	"./flags/1x1/KR.svg": 77816,
	"./flags/1x1/KW.svg": 66400,
	"./flags/1x1/KY.svg": 47044,
	"./flags/1x1/KZ.svg": 46168,
	"./flags/1x1/LA.svg": 82728,
	"./flags/1x1/LB.svg": 26492,
	"./flags/1x1/LC.svg": 47808,
	"./flags/1x1/LI.svg": 16304,
	"./flags/1x1/LK.svg": 73076,
	"./flags/1x1/LR.svg": 20220,
	"./flags/1x1/LS.svg": 25008,
	"./flags/1x1/LT.svg": 12216,
	"./flags/1x1/LU.svg": 77888,
	"./flags/1x1/LV.svg": 44480,
	"./flags/1x1/LY.svg": 44832,
	"./flags/1x1/MA.svg": 76968,
	"./flags/1x1/MC.svg": 58908,
	"./flags/1x1/MD.svg": 47792,
	"./flags/1x1/ME.svg": 59348,
	"./flags/1x1/MF.svg": 5168,
	"./flags/1x1/MG.svg": 96408,
	"./flags/1x1/MH.svg": 30332,
	"./flags/1x1/MK.svg": 21700,
	"./flags/1x1/ML.svg": 93288,
	"./flags/1x1/MM.svg": 64664,
	"./flags/1x1/MN.svg": 36076,
	"./flags/1x1/MO.svg": 96976,
	"./flags/1x1/MP.svg": 14560,
	"./flags/1x1/MQ.svg": 42332,
	"./flags/1x1/MR.svg": 96392,
	"./flags/1x1/MS.svg": 58180,
	"./flags/1x1/MT.svg": 7912,
	"./flags/1x1/MU.svg": 38476,
	"./flags/1x1/MV.svg": 29164,
	"./flags/1x1/MW.svg": 48836,
	"./flags/1x1/MX.svg": 3568,
	"./flags/1x1/MY.svg": 59288,
	"./flags/1x1/MZ.svg": 25664,
	"./flags/1x1/NA.svg": 60056,
	"./flags/1x1/NC.svg": 41972,
	"./flags/1x1/NE.svg": 97824,
	"./flags/1x1/NF.svg": 25728,
	"./flags/1x1/NG.svg": 73400,
	"./flags/1x1/NI.svg": 23964,
	"./flags/1x1/NL.svg": 39446,
	"./flags/1x1/NO.svg": 14672,
	"./flags/1x1/NP.svg": 7200,
	"./flags/1x1/NR.svg": 50920,
	"./flags/1x1/NU.svg": 73834,
	"./flags/1x1/NZ.svg": 34100,
	"./flags/1x1/OM.svg": 76668,
	"./flags/1x1/PA.svg": 19672,
	"./flags/1x1/PE.svg": 28532,
	"./flags/1x1/PF.svg": 52644,
	"./flags/1x1/PG.svg": 41612,
	"./flags/1x1/PH.svg": 67952,
	"./flags/1x1/PK.svg": 88980,
	"./flags/1x1/PL.svg": 82524,
	"./flags/1x1/PM.svg": 74608,
	"./flags/1x1/PN.svg": 31008,
	"./flags/1x1/PR.svg": 91264,
	"./flags/1x1/PS.svg": 68988,
	"./flags/1x1/PT.svg": 1624,
	"./flags/1x1/PW.svg": 328,
	"./flags/1x1/PY.svg": 74784,
	"./flags/1x1/QA.svg": 54648,
	"./flags/1x1/RE.svg": 75096,
	"./flags/1x1/RO.svg": 47976,
	"./flags/1x1/RS.svg": 56740,
	"./flags/1x1/RU.svg": 17872,
	"./flags/1x1/RW.svg": 95106,
	"./flags/1x1/SA.svg": 2424,
	"./flags/1x1/SB.svg": 34276,
	"./flags/1x1/SC.svg": 19944,
	"./flags/1x1/SD.svg": 19612,
	"./flags/1x1/SE.svg": 87184,
	"./flags/1x1/SG.svg": 45748,
	"./flags/1x1/SH.svg": 724,
	"./flags/1x1/SI.svg": 77712,
	"./flags/1x1/SJ.svg": 56892,
	"./flags/1x1/SK.svg": 16824,
	"./flags/1x1/SL.svg": 70088,
	"./flags/1x1/SM.svg": 1352,
	"./flags/1x1/SN.svg": 96868,
	"./flags/1x1/SO.svg": 44160,
	"./flags/1x1/SR.svg": 91808,
	"./flags/1x1/SS.svg": 19876,
	"./flags/1x1/ST.svg": 15584,
	"./flags/1x1/SV.svg": 60880,
	"./flags/1x1/SX.svg": 13016,
	"./flags/1x1/SY.svg": 88408,
	"./flags/1x1/SZ.svg": 98124,
	"./flags/1x1/TA.svg": 54732,
	"./flags/1x1/TC.svg": 18424,
	"./flags/1x1/TD.svg": 90964,
	"./flags/1x1/TF.svg": 81832,
	"./flags/1x1/TG.svg": 67460,
	"./flags/1x1/TH.svg": 74788,
	"./flags/1x1/TJ.svg": 92008,
	"./flags/1x1/TK.svg": 62620,
	"./flags/1x1/TL.svg": 8599,
	"./flags/1x1/TM.svg": 1568,
	"./flags/1x1/TN.svg": 57592,
	"./flags/1x1/TO.svg": 37808,
	"./flags/1x1/TR.svg": 30498,
	"./flags/1x1/TT.svg": 64348,
	"./flags/1x1/TV.svg": 82277,
	"./flags/1x1/TW.svg": 66964,
	"./flags/1x1/TZ.svg": 44452,
	"./flags/1x1/UA.svg": 43104,
	"./flags/1x1/UG.svg": 54540,
	"./flags/1x1/US.svg": 69980,
	"./flags/1x1/UY.svg": 64948,
	"./flags/1x1/UZ.svg": 74248,
	"./flags/1x1/VA.svg": 17564,
	"./flags/1x1/VC.svg": 58944,
	"./flags/1x1/VE.svg": 10072,
	"./flags/1x1/VG.svg": 44080,
	"./flags/1x1/VI.svg": 45680,
	"./flags/1x1/VN.svg": 88940,
	"./flags/1x1/VU.svg": 80160,
	"./flags/1x1/WF.svg": 62536,
	"./flags/1x1/WS.svg": 90664,
	"./flags/1x1/XK.svg": 36892,
	"./flags/1x1/YE.svg": 86244,
	"./flags/1x1/YT.svg": 2496,
	"./flags/1x1/ZA.svg": 49380,
	"./flags/1x1/ZM.svg": 56168,
	"./flags/1x1/ZW.svg": 31536
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66504;